import pino from 'pino';

const logger = pino({ level: process.env.LOG_LEVEL || inferDefaultLogLevel() });

export const log = logger;

// Production do not print any log wth level lower than warn
// Pino levels: trace(10)	debug(20)	info(30)	warn(40)	error(50)	fatal(60)	silent(infinity)
function inferDefaultLogLevel() {
  if (process.env.NODE_ENV === 'test' && process.env.DEBUG_TEST == null) {
    return 'silent';
  }

  if (process.env.NODE_ENV === 'production') {
    return 'warn';
  }

  return 'debug';
}
